"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardAction = void 0;
const ot_1 = require("../engine/ot");
class DashboardAction {
    // install widget
    static addWidget2Action(snapshot, options) {
        var _a;
        const widgetInstallations = snapshot.widgetInstallations;
        const widgetCount = (_a = widgetInstallations.layout) === null || _a === void 0 ? void 0 : _a.length;
        const { layout } = options;
        if (!widgetCount) {
            // first join
            return [
                {
                    n: ot_1.OTActionName.ObjectInsert,
                    p: ['widgetInstallations', 'layout'],
                    oi: layout,
                },
            ];
        }
        const action = [];
        layout.forEach((widget, index) => {
            action.push({
                n: ot_1.OTActionName.ListInsert,
                p: ['widgetInstallations', 'layout', widgetCount + index],
                li: widget,
            });
        });
        return action;
    }
    // delete widget
    static deleteWidget2Action(snapshot, widgetId) {
        const layout = snapshot.widgetInstallations.layout;
        const layoutIndex = layout.findIndex(item => item.id === widgetId);
        return [
            {
                n: ot_1.OTActionName.ListDelete,
                p: ['widgetInstallations', 'layout', layoutIndex],
                ld: layout[layoutIndex],
            },
        ];
    }
    // change the layout of widgets
    static changeWidgetLayout2Action(snapshot, options) {
        const oldLayout = snapshot.widgetInstallations.layout;
        const { layout } = options;
        if (layout.length !== (oldLayout === null || oldLayout === void 0 ? void 0 : oldLayout.length)) {
            return null;
        }
        const actions = [];
        oldLayout.map((oldPosition, index) => {
            const newPosition = layout[index];
            for (const k in oldPosition) {
                actions.push({
                    n: ot_1.OTActionName.ObjectReplace,
                    p: ['widgetInstallations', 'layout', index, k],
                    oi: newPosition[k],
                    od: oldPosition[k],
                });
            }
        });
        return actions;
    }
}
exports.DashboardAction = DashboardAction;
//# sourceMappingURL=dashboard.js.map